import {Action} from '@ngrx/store';
import {AppState} from '../AppState';

const SET_SHOW_HEADER = '[ui] Show Header';

export function showHeader(state: boolean = true, action: SetShowHeaderAction): boolean {
  switch (action.type) {
    case SET_SHOW_HEADER:
      return action.payload;
    default:
      return state;
  }
}

export class SetShowHeaderAction implements Action {
  readonly type = SET_SHOW_HEADER;

  constructor(public payload: boolean) {}
}

export const getShowHeader = (state: AppState) => state.showHeader;
